module.exports = __webpack_public_path__ + "media/images/nikon-05f978452f7147430094ccc0a22112ab.svg";